export default "__VITE_ASSET__QGkBE9io__"